<div *ngIf="!isMobile" class="timer-group" [class.warning]="warning">

  <div class="timer-title">
    <p *ngIf="title">{{title}}</p>
    <div class="separator"></div>
    <p *ngIf="subtitle">{{subtitle}}</p>
  </div>

  <div class="timer-sub-group" [class.has-title]="title">

    <div class="right-arrow-container">
      <svg width="100%" height="100%" viewBox="0 0 116 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" 
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><rect id="CountdownTimerArrow" x="-129" y="0" width="244.006" height="64" style="fill:none;"/>
      <clipPath id="_clip1"><rect x="-129" y="0" width="244.006" height="64"/></clipPath><g clip-path="url(#_clip1)"><g id="CountdownTimer_Compact">
        <path d="M23.559,32l-23.56,32l-0.003,-64l23.563,32Zm-23.56,32l-128.999,0l0,-64l128.996,0l0.003,64Z" style="fill:var(--secondary);"/>
        <path d="M32.585,16l0,-16l25.027,32l-24.622,32l0.035,-16.44l12.074,-15.56l-12.514,-16Zm-12.514,48l12.954,-16.44l-0.035,16.44l-133.232,0c0,0 120.313,0 120.313,0l0,-64l0,64Zm12.514,-48l-12.514,-16l12.514,0l0,16Z" 
        style="fill:var(--secondary);"/><path d="M60.36,16l0,-16l25.027,32l-25.027,32l0,-16l12.514,-16l-12.514,-16Zm-12.514,48l12.514,-16l0,16l-132.827,0c0,0 120.313,0 120.313,0l0,-64l0,64Zm12.514,-48l-12.514,-16l12.514,0l0,16Z" 
        style="fill:var(--secondary);"/><path d="M89.973,16l0,-16l25.027,32l-25.027,32l0,-16l12.513,-16l-12.513,-16Zm-12.514,48l12.514,-16l0,16l-132.827,0c0,0 120.313,0 120.313,0l0,-64l0,64Zm12.514,-48l-12.514,-16l12.514,0l0,16Z" 
        style="fill:var(--secondary);"/></g></g></svg>
    </div>

    <div class="timer-sub-container">
      <div class="timer-item days">
        <span class="item-count">{{days}}</span>
        <span class="item-desc">Days</span>
      </div>

      <div class="timer-item hours">
        <span class="item-count">{{hours}}</span>
        <span class="item-desc">Hours</span>
      </div>

      <div class="timer-item minutes">
        <span class="item-count">{{minutes}}</span>
        <span class="item-desc">Minutes</span>
      </div>

      <div class="timer-item seconds">
        <span class="item-count">{{seconds}}</span>
        <span class="item-desc">Seconds</span>
      </div>
    </div>

    <div class="left-arrow-container">
      <svg width="100%" height="100%" viewBox="0 0 116 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" 
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;transform: rotate(180deg)"><rect id="CountdownTimerArrow" x="-129" y="0" width="244.006" height="64" style="fill:none;"/>
      <clipPath id="_clip1"><rect x="-129" y="0" width="244.006" height="64"/></clipPath><g clip-path="url(#_clip1)"><g id="CountdownTimer_Compact">
        <path d="M23.559,32l-23.56,32l-0.003,-64l23.563,32Zm-23.56,32l-128.999,0l0,-64l128.996,0l0.003,64Z" style="fill:var(--secondary);"/>
        <path d="M32.585,16l0,-16l25.027,32l-24.622,32l0.035,-16.44l12.074,-15.56l-12.514,-16Zm-12.514,48l12.954,-16.44l-0.035,16.44l-133.232,0c0,0 120.313,0 120.313,0l0,-64l0,64Zm12.514,-48l-12.514,-16l12.514,0l0,16Z" 
        style="fill:var(--secondary);"/><path d="M60.36,16l0,-16l25.027,32l-25.027,32l0,-16l12.514,-16l-12.514,-16Zm-12.514,48l12.514,-16l0,16l-132.827,0c0,0 120.313,0 120.313,0l0,-64l0,64Zm12.514,-48l-12.514,-16l12.514,0l0,16Z" 
        style="fill:var(--secondary);"/><path d="M89.973,16l0,-16l25.027,32l-25.027,32l0,-16l12.513,-16l-12.513,-16Zm-12.514,48l12.514,-16l0,16l-132.827,0c0,0 120.313,0 120.313,0l0,-64l0,64Zm12.514,-48l-12.514,-16l12.514,0l0,16Z" 
        style="fill:var(--secondary);"/></g></g></svg>
    </div>
    
  </div>

</div>

<div *ngIf="isMobile">

  <div class="mobile-timer-title">
    <p *ngIf="title">{{title}}<span *ngIf="subtitle"> | {{subtitle}}</span></p> 
  </div>
  <div class="timer-group mobile">
    <div class="timer-sub-group">
      <div class="timer-sub-container">
        <div class="timer-item days">
          <span class="item-count">{{days}}</span>
          <span class="item-desc">Days</span>
        </div>

        <div class="timer-item hours">
          <span class="item-count">{{hours}}</span>
          <span class="item-desc">Hours</span>
        </div>

        <div class="timer-item minutes">
          <span class="item-count">{{minutes}}</span>
          <span class="item-desc">Minutes</span>
        </div>

        <div class="timer-item seconds">
          <span class="item-count">{{seconds}}</span>
          <span class="item-desc">Seconds</span>
        </div>
      </div>
      
    </div>
  </div>
</div>
